import { Theme, createStyles, makeStyles } from '@forgeglobal/design-framework';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    wrapper: {
      display: 'grid',
      gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
      gridColumnGap: theme.spacing(3),
      marginBottom: theme.spacing(6),

      // fix for horizontal layout
      '& .MuiCard-root+.MuiCard-root': {
        marginTop: 0,
      },
      [theme.breakpoints.down('md')]: {
        gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
        gridRowGap: theme.spacing(3),
      },
      [theme.breakpoints.down('sm')]: {
        gridTemplateColumns: '1fr',
        gridRowGap: theme.spacing(3),
      },
    },
    itemContent: {
      marginTop: theme.spacing(7.5),
    },
  })
);
